if (!customElements.get("product-add-ons")) {
  class ComponentAddOns extends HTMLElement {
    constructor() {
      super();
      this.card = this.querySelectorAll(".add-on");
      this.btnsAdd = this.querySelectorAll(".btn-add");
      this.variants = this.querySelectorAll(".variants .swatch input[type=radio]");

      this.initButtons();
      this.initVariants();

      // pre-select first variant
      this.card.forEach((card) => {
        const items = card.querySelectorAll(".variants .swatch input[type=radio]");
        const firstInput = items[0];
        if (firstInput) {
          firstInput.dispatchEvent(new Event("change", { bubbles: true }));
          const label = card.querySelector(`label[for="${firstInput.id}"]`);
          label?.classList.add("active");
        }
      });
    }

    initVariants() {
      this.variants.forEach((variant) => {
        variant.addEventListener("change", (event) => {
          const addOnElement = event.currentTarget.closest(".add-on");
          const selectedOption = event.currentTarget;
          const newVariantId = selectedOption.value;
          const price = selectedOption.dataset.price;
          const image = selectedOption.dataset.image;
          const available = selectedOption.closest('.swatch').dataset.available;

          if (addOnElement) {

            // deselect first variant
            const allLabels = addOnElement.querySelectorAll("label");
            allLabels.forEach((label) => {
              label.classList.remove("active");
            });

            addOnElement.setAttribute("data-product", newVariantId);
            //addOnElement.querySelector(".btn-add").classList.remove("hide");
            //addOnElement.querySelector(".btn-remove").classList.add("hide");
            //addOnElement.querySelector(".btn-remove").setAttribute("disabled", "false");

            if(available == "false") {
              addOnElement.querySelector(".btn-add").setAttribute("disabled", "true");
              addOnElement.querySelector(".btn-add").innerHTML = "Sold out";
            } else {
              addOnElement.querySelector(".btn-add").removeAttribute("disabled");
              addOnElement.querySelector(".btn-add").innerHTML = "Add";
            }
            
            // update ProductCard
            const priceElement = addOnElement.querySelector(".product-price");
            if (priceElement)
              priceElement.textContent = `$${parseFloat(price).toFixed(2)}`;

            const imageElement = addOnElement.querySelector("img");
            if (imageElement && image){
              imageElement.removeAttribute("data-srcset");
              imageElement.removeAttribute("data-src");
              imageElement.removeAttribute("srcset");
              imageElement.src = image;
            }

            this.renderSubscriptionOptionsFromData(addOnElement, selectedOption);
            
            // pre-select first option
            const select = addOnElement.querySelector(".subscription-option");
            if (select && select.options.length > 0) {
              select.selectedIndex = 0;
              select.dispatchEvent(new Event("change", { bubbles: true }));
            }

          }
        });
      });
    }

    renderSubscriptionOptionsFromData(addOnElement, selectedVariantInput) {
      let wrapper = addOnElement.querySelector('.subscription-options');
      const raw = selectedVariantInput ? selectedVariantInput.dataset.sellingPlans : null;
      let plans = [];
      if (raw) {
        try {
          plans = JSON.parse(raw);
          if (!Array.isArray(plans)) plans = [];
        } catch (e) {
          console.warn('Error data-selling-plans', e, raw);
          plans = [];
        }
      }
      
      const nodes = [];

      // SUBSCRIPTION
      if (plans && plans.length > 0) {
        nodes.push('<select class="subscription-option" name="subscription-option">');
        plans.forEach(plan => {
          const planId = plan.id || plan.selling_plan_id || plan.plan_id || JSON.stringify(plan);
          let planLabel = plan.name;
          nodes.push(`<option data-price="${plan.price}" data-compare-at-price="${plan.compare_at_price}" value="${planId}">
            ${planLabel}
          </option>`);
        });
        nodes.push('</select>');
      }
      wrapper.innerHTML = nodes.join('');      

      // update Prices
      if (plans && plans.length > 0) {
        this.subscriptionPrice(addOnElement);
      }
    }

    subscriptionPrice(addOnElement) {
      const subscriptionSelect = addOnElement.querySelector('.subscription-option');
      if(subscriptionSelect){
        subscriptionSelect.addEventListener("change", (event) => {
          const selectedOption = event.target.options[event.target.selectedIndex];
          const price = selectedOption.dataset.price;
          const compareAtPrice = selectedOption.dataset.compareAtPrice; 
          this.updatePriceCard(addOnElement, price, compareAtPrice);
        });
      }
    }

    updatePriceCard(addOnElement, price, compareAtPrice){
      const card = addOnElement.querySelector('.product-price');
      card.innerHTML = `<span class="compare">$${compareAtPrice}</span><span class="final price-field">$${price}<span>`;
    }

    initButtons() {
      this.btnsAdd.forEach((btnAdd) => {
        btnAdd.addEventListener("click", (event) => {
          event.preventDefault();
          const addOnElement = event.currentTarget.closest(".add-on");
          const productId = addOnElement.dataset.product;
          const sellingPlanId = addOnElement.querySelector('.subscription-option').value;
          if (addOnElement) {
            this.addProduct(productId, sellingPlanId).then(result => {
              if(result){
                // addOnElement.querySelector(".btn-add").classList.add("hide");
                // addOnElement.querySelector(".btn-remove").classList.remove("hide");
                // addOnElement.querySelector(".btn-remove").setAttribute("disabled", "true");
                $s.addToCartSuccess();
              }
            });
          }
        });
      });
    }
    
    addProduct(productId, sellingPlanId) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: productId, quantity: 1, selling_plan: sellingPlanId }]
        })
      })
      .then(response => response.json())
      .then(data => true)
      .catch(error => false);
    }

  }
  customElements.define("product-add-ons", ComponentAddOns);
}
